const genSpaceCompactStyle = token => {
  const componentCls = token.componentCls;
  return {
    [componentCls]: {
      '&-block': {
        display: 'flex',
        width: '100%'
      },
      '&-vertical': {
        flexDirection: 'column'
      }
    }
  };
};
// ============================== Export ==============================
export default genSpaceCompactStyle;